import React from 'react';
import { Container, Grid } from '@material-ui/core';
import { string, bool, shape } from 'prop-types';
import HeadlineLarge from '../HeadlineLarge';
import styles from './HeroSection.module.scss';
import variables from '../../styles/variables.module.scss';
import SideHeading from '../SideHeading';

const HeroSection = ({
  title,
  stroke,
  strokeColor,
  headline,
  backgroundColor,
  firstSideHeading,
  secondSideHeading,
  image,
  offset,
}) => (
  <div
    className={[styles.container, offset ? styles.containerOffset : null].join(' ')}
    style={image
      ? {
        background: `url(${image.main}) center center no-repeat, url(${image.fall}) center center no-repeat`,
        backgroundSize: 'cover',
      } : {
        backgroundColor,
      }}
  >
    <Container
      className={[
        styles.containerInner,
        offset ? styles.containerInnerOffset : null,
      ].join(' ')}
    >
      <Grid
        container
        direction="column"
        justify="center"
        className={[
          styles.containerInner,
          offset ? styles.containerInnerOffset : null,
        ].join(' ')}
      >
        <Grid item xs className={styles.containerTitle}>
          <Grid container justify="space-between" style={{ position: 'relative' }}>
            <Grid item sm={8} md={6}>
              <h3 className={styles.titleHero}>{title}</h3>
            </Grid>
            <SideHeading
              firstHeading={firstSideHeading}
              secondHeading={secondSideHeading}
              className={styles.sideHeadingHero}
            />
          </Grid>
        </Grid>
        <Grid item xs="auto">
          <Grid container justify="flex-end" className={styles.containerHeadline}>
            <Grid item xs="auto">
              <HeadlineLarge
                stroke={stroke}
                strokeColor={strokeColor}
                className={styles.gridHeadline}
                style={!title ? { paddingTop: '100px' } : null}
              >
                {headline}
              </HeadlineLarge>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  </div>
);

HeroSection.propTypes = {
  title: string,
  stroke: string,
  strokeColor: string,
  headline: string,
  backgroundColor: string,
  firstSideHeading: string,
  secondSideHeading: string,
  image: shape({
    main: string,
    fall: string,
  }),
  offset: bool,
};

HeroSection.defaultProps = {
  title: null,
  stroke: null,
  strokeColor: variables.cleanWhite,
  headline: null,
  backgroundColor: variables.tuna,
  firstSideHeading: null,
  secondSideHeading: null,
  image: null,
  offset: false,
};

export default HeroSection;
